import { DomainError } from "./errors";
import { roundHalfAwayFromZero } from "./money";

/** Hungarian standard VAT rates in percent (27 general, 18 and 5 reduced, 0 exempt). */
export const HU_VAT_RATES = [27, 18, 5, 0] as const;

export function assertVatRate(rate: number): void {
  if (!Number.isFinite(rate) || rate < 0 || rate > 100) {
    throw new DomainError("INVALID_VAT_RATE", String(rate));
  }
}

/** VAT amount for a net amount (minor units), rounded commercially. */
export function vatFromNet(netMinor: number, ratePercent: number): number {
  assertVatRate(ratePercent);
  return roundHalfAwayFromZero((netMinor * ratePercent) / 100);
}

/** Net part of a gross amount (minor units). Net + VAT always equals the gross exactly. */
export function netFromGross(grossMinor: number, ratePercent: number): number {
  assertVatRate(ratePercent);
  return roundHalfAwayFromZero((grossMinor * 100) / (100 + ratePercent));
}
